export const VERSAO_SISTEMA_PADRAO = "1.1.4";
